import React from "react";
//import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import "./spotifyListen.scss";
interface SpotifyInterface {
  link: string;
}
const SpotifyListen = (props: SpotifyInterface) => {
  return (
    <div className="a-spotifybox">
      <div className="a-spotifybox-container">
        <iframe
          className="a-spotifybox-container-link"
          src={props.link}
          allow="encrypted-media"
        ></iframe>
      </div>
    </div>
  );
};
export default SpotifyListen;
